module.exports = __webpack_public_path__ + "img/parallax.39ed2cf7.png";